import { sendAIChat, createAIChatThread, deleteAIChatThread, sendAIChatBot } from '@/graphql/mutations';
import API from '@aws-amplify/api';
import { getPublicAPI } from './publicService';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';

export const sendAIChatMessage = async (APIClient, requestDto, setListMessageContent, setIsDisabledInputChat) => {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const result = await API.graphql({
            query: sendAIChat,
            variables: {
                sendAIChatRequestDto: {
                   ...requestDto,
                   timeZone: timeZone
                    
                }
            },
        });

        return result?.data?.sendAIChat?.responseMessage
    } catch (err) {
        console.log('sendAIChatMessage err >>> ', err);
        let errMessage = err.errors[0].message
        if (errMessage === I18n.get('MSG-AI-LICENSE-KEY-HAVE-BEEN-INVALID-CONTACT-ADMIN') || errMessage?.includes(I18n.get('MSG_OPEN_AI_API_ERROR_PATH_TERM'))) {
            let responseMessage = {
                isFromMe: false,
                content: errMessage,
                isError: true,
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date())
            };
            setListMessageContent(prevArray => {
                const newArray = [...prevArray];
                if (newArray.length > 0) {
                    newArray[newArray.length - 1] = responseMessage;
                    return newArray;
                }
                return [responseMessage];
            });
            setIsDisabledInputChat(true);
        }
        return null;
    }
};

export const deleteAiChatThread = async (APIClient, id) => {
    try {
        const result = await API.graphql({
            query: deleteAIChatThread,
            variables: {
                input: {
                    id: id,
                },
            },
        });
        return result.data.deleteAIChatThread;
    } catch (err) {
        console.log('deleteAiChatThread err:', err);
        return null;
    }
}

export const createNewAIChatThread = async (chatThreadDto) => {
    let input = {
        query: createAIChatThread,
        variables: {
            input: chatThreadDto
        }
    };

    try {
        let resData = await API.graphql(input);
        return resData.data?.createAIChatThread;
    } catch (err) {
        console.log('createNewAIChatThread :>> ', err);
        return null;
    }
};

export const getListMessageChat = async (APIClient, chatThreadId, ticketId = '') => {
    try {
        let params = {
            getApiType: 'getListAIChatPost',
            chatThreadId: chatThreadId
        };

        if (ticketId) {
            params.ticketId = ticketId
        }

        let result = await getPublicAPI(API, params);
        if (result?.errors === 'DELETED') {
            return false;
        }
        let response = Utils.convertJSONDataToObject(result.payload)

        return response;
    } catch (err) {
        console.log('getListMessageChat err: ', err);
        return false;
    }
};

export const sendAiChatBotApi = async (requestDto,setMessages,getCurrentTimeForMessage) => {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let res = await API.graphql({
            query: sendAIChatBot,
            variables: {
                sendAIChatBotRequestDto: {
                    ...requestDto,
                    timeZone: timeZone
                }
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        
        return res.data.sendAIChatBot?.responseMessage;
    } catch (err) {
        console.log(err);
        let errMessage = err.errors[0].message
        if (errMessage === I18n.get('MSG-AI-LICENSE-KEY-HAVE-BEEN-INVALID-CONTACT-ADMIN') || errMessage?.includes(I18n.get('MSG_OPEN_AI_API_ERROR_PATH_TERM'))) {
            let responseMessage = {
                isFromMe: false,
                content: errMessage,
                isError: true,
                idMessage: getCurrentTimeForMessage()
            };
            setMessages(prevArray => {
                let newArray = [...prevArray];
                if (newArray.length > 0) {
                    newArray[newArray.length - 1] = responseMessage;
                    return newArray;
                }
                return [responseMessage];
            });
        }
        return null;
    }
}

export const getListChatThread = async (ids) => {
    try {
        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_LIST_CHAT_THREAD,
            ids: ids
        };

        let result = await getPublicAPI(API, params);
        
        let response = Utils.convertJSONDataToObject(result.payload);
        return response;
        
    } catch (error) {
        console.log('getListChatThread error: ', error);
        return [];
    }
}

export const getListAttachImageByAiChatPost = async (aiChatPost) => {
    try {
        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_LIST_ATTACH_FILE_BY_AI_CHAT_POST,
            chatPost: aiChatPost
        };
        let result = await getPublicAPI(API, params);
        let response = Utils.convertJSONDataToObject(result.payload);

        if (Array.isArray(response)) {
            return response;
        }

        return []
        
    } catch (error) {
        console.log('getListChatThread error: ', error);
        return [];
    }
}

export const getNameTabChatAiWhenFirstMsgNoContent = async (firstChatMsg) => {
    try {
        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_NAME_TAB_CHAT_AI_WHEN_FIRST_MSG_NO_CONTENT,
            chatPost: firstChatMsg
        };
        let result = await getPublicAPI(API, params);
        let response = Utils.convertJSONDataToObject(result.payload);

        return response.tabChatAiName || '';
    } catch (error) {
        console.log('getNameTabChatAiWhenFirstMsgNoContent error: ', error);
        return '';
    }
}
